import styled, { css } from 'styled-components';
import { getTypographyStyles, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_1400, SYS_SIZE_FIXED_1600, SYS_SIZE_FIXED_1800, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, getMargins, SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL, SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL, SYS_SPACE_FIXED_400, SYS_SPACE_FIXED_300, SYS_BORDER_RADIUS_MAX, SYS_BORDER_WIDTH_100 } from '@oneaudi/unified-web-alpha-common';
import { IconButton } from '../icon-button/index.js';
import {} from './index.js';
import { Icon } from '../icon/index.js';
export const StyledOuter = styled.div `
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledTabList = styled.ul `
  margin: 0;
  padding: 0;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  flex-wrap: nowrap;
  gap: ${SYS_SPACE_FIXED_100};
  margin: 0 ${SYS_SPACE_FIXED_100};

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledListItem = styled.li `
  list-style-type: none;
  flex: 1 0 auto;
  display: flex;
`;
export const StyledIcon = styled(Icon) ``;
export const StyledTabItemInner = styled.div `
  position: relative;
  align-items: center;
  display: flex;
  gap: ${(props) => props.size === 'sm' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};
`;
export const StyledTabItem = styled.button `
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline-offset: -3px;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, box-shadow, background-color;
  ${(props) => css `
    min-height: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1200
    : SYS_SIZE_FIXED_1400};

    min-width: ${props.size === 'sm'
    ? SYS_SIZE_FIXED_1600
    : SYS_SIZE_FIXED_1800};

    ${getTypographyStyles(props.size === 'sm'
    ? SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL
    : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL)};

    padding: 0
      ${props.size === 'sm' ? SYS_SPACE_FIXED_300 : SYS_SPACE_FIXED_400};
  `}

  ${(props) => props.active
    ? css `
          color: ${props.theme.cmp.color.navigation.tabs.foreground.text
        .active};
          background-color: ${props.theme.cmp.color.navigation.tabs.surface.fill
        .active};
          box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
            ${props.theme.cmp.color.navigation.tabs.surface.stroke.active};

          ${StyledIcon} {
            color: ${props.theme.cmp.color.navigation.tabs.foreground.icon
        .active};
          }
        `
    : css `
          color: ${(props) => props.theme.cmp.color.navigation.tabs.foreground.text.default};
          background-color: ${props.theme.cmp.color.navigation.tabs.surface.fill
        .default};
          box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
            ${props.theme.cmp.color.navigation.tabs.surface.stroke.default};

          ${StyledIcon} {
            color: ${props.theme.cmp.color.navigation.tabs.foreground.icon
        .default};
          }
        `}


  ${(props) => css `
    &:disabled {
      cursor: not-allowed;
      color: ${props.theme.cmp.color.navigation.tabs.foreground.text.disabled};
      background-color: ${props.theme.cmp.color.navigation.tabs.surface.fill
    .disabled};
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.navigation.tabs.surface.stroke.disabled};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.navigation.tabs.foreground.icon
    .disabled};
      }
    }

    &:active:not(:disabled),
    &:hover:not(:disabled) {
      color: ${(props) => props.theme.cmp.color.navigation.tabs.foreground.text.interactive};
      background-color: ${props.theme.cmp.color.navigation.tabs.surface.fill
    .interactive};
      box-shadow: inset 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.cmp.color.navigation.tabs.surface.stroke.interactive};

      ${StyledIcon} {
        color: ${props.theme.cmp.color.navigation.tabs.foreground.icon
    .interactive};
      }
    }
  `}
`;
export const StyledTabItemContainer = styled.div `
  display: flex;
  position: relative;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
`;
export const StyledIconButton = styled(IconButton) `
  flex-shrink: 0;
`;
export const StyledTabPanel = styled.div `
  display: none;
  padding: ${SYS_SPACE_FIXED_200};
  ${(props) => props.active &&
    css `
      display: block;
    `};
`;
//# sourceMappingURL=index.styles.js.map